import { DataGridPro, DataGridProProps, GridEventListener, GridValidRowModel, useGridApiRef } from '@mui/x-data-grid-pro';
import { BooleanCellFalseChip } from '../_renderers/BooleanCellFalseChip';
import { BooleanCellTrueChip } from '../_renderers/BooleanCellTrueChip';
import { composeZebraRowClassName } from '../_helpers/composeZebraRowClassName';

export const CompactDataGrid = <T extends GridValidRowModel>(props: DataGridProProps<T>) => {
  const { onCellClick, apiRef: apiRefProp, columns, getRowClassName, ...restProps } = props;
  const internalApiRef = useGridApiRef();
  const apiRef = apiRefProp ?? internalApiRef;

  const handleCellClick: GridEventListener<'cellClick'> = (params, event, details) => {
    event.defaultMuiPrevented = true;
    const { cellMode, id, field } = params;

    if (cellMode !== 'edit' && apiRef.current.isCellEditable(params)) {
      apiRef.current.startCellEditMode({ id, field });
    }

    onCellClick?.(params, event, details);
  };

  return (
    <DataGridPro
      apiRef={apiRef}
      disableRowSelectionOnClick={true}
      pagination={false}
      hideFooter={true}
      columns={columns}
      disableColumnMenu={true}
      getRowClassName={composeZebraRowClassName<T>(getRowClassName)}
      slots={{
        booleanCellTrueIcon: BooleanCellTrueChip,
        booleanCellFalseIcon: BooleanCellFalseChip,
      }}
      onCellClick={handleCellClick}
      {...restProps}
    />
  );
};
